module.exports = __webpack_public_path__ + "static/media/flash.fa72b2d6.png";